import { WizardStep } from "@/modes/mode";
import {
  selectIpxEstimatedRegionBytes,
  selectIpxRegionPlanArea,
} from "@/store/modes/ipx-order-mode-selectors";
import { setIpxCheckout } from "@/store/modes/ipx-order-mode-slice";
import { humanReadableBytes } from "@faro-lotv/foundation";
import { IPX_MOCK_SIZE_LIMIT_BYTES } from "./ipx-config";
import { DefineAreaPanel } from "./steps/define-area-step";
import { OrderPlacedPanel } from "./steps/order-placed-step";
import { ReviewPanel } from "./steps/review-step";

/** Keys of the steps of the IPX ordering wizard */
export enum IpxOrderStepKey {
  defineArea = "defineArea",
  review = "review",
  placed = "placed",
}

export const IPX_ORDER_STEPS: WizardStep[] = [
  {
    key: IpxOrderStepKey.defineArea,
    label: "Select data",
    instructions:
      "Check the scans to send. The box fits around them; drag its handles to keep only the part of the building you need.",
    hint: "Drag the box handles to fit the volume you need",
    isCanvasFocused: true,
    Panel: DefineAreaPanel,
    selectCanContinue: (state) => {
      if (!state.ipxOrderMode.pointCloudId) return "Select a dataset.";
      const bytes = selectIpxEstimatedRegionBytes(state);
      if (bytes === undefined) return "Loading the point cloud…";
      if (bytes > IPX_MOCK_SIZE_LIMIT_BYTES) {
        return `The selected data is about ${humanReadableBytes(bytes, 1)}, IPX accepts up to ${humanReadableBytes(IPX_MOCK_SIZE_LIMIT_BYTES)}. Make the box smaller or remove scans.`;
      }
      return true;
    },
  },
  {
    key: IpxOrderStepKey.review,
    label: "Review",
    instructions:
      "Check that the floors match the building you need. You choose the deliverables and pay in the IPX checkout.",
    Panel: ReviewPanel,
    primaryActionLabel: "Continue to IPX checkout",
    selectCanContinue: (state) =>
      selectIpxRegionPlanArea(state) !== undefined || "Measuring the floors…",
    onPrimaryAction({ dispatch }) {
      dispatch(setIpxCheckout("open"));
      return Promise.resolve();
    },
  },
  {
    key: IpxOrderStepKey.placed,
    label: "Order placed",
    instructions:
      "Your order was placed and paid at IPX. Follow its status in Cloud activity, the results are added to this project once IPX delivers them.",
    Panel: OrderPlacedPanel,
    primaryActionLabel: "Finish",
    preventBack: true,
    selectCanContinue: (state) =>
      !!state.ipxOrderMode.order || "The order has not been placed.",
  },
];
